var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteRichText = function SvgGradientWhiteRichText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.978 13.373c3.525 0 6.382-2.842 6.382-6.349 0-3.506-2.857-6.35-6.382-6.35-3.525 0-6.382 2.844-6.382 6.35 0 3.507 2.857 6.35 6.382 6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.728 4.417c0-.522-.448-.945-1.002-.945H10.72c-.553 0-1.002.423-1.002.945s.449.945 1.002.945h4.007c.553 0 1.002-.423 1.002-.945Zm-3.005 2.835c.553 0 1.002-.423 1.002-.945v-3.78c0-.522-.449-.945-1.002-.945-.553 0-1.002.423-1.002.945v3.78c0 .522.449.945 1.002.945ZM.299 11.193c-.257.61.22 1.273.917 1.273h.408a.985.985 0 0 0 .927-.613l.598-1.558H7.87l.613 1.563a.985.985 0 0 0 .925.608h.41c.698 0 1.175-.663.917-1.274L6.937 2.194a.987.987 0 0 0-.916-.586H5a.987.987 0 0 0-.917.587L.3 11.193ZM3.843 8.46l1.643-4.237a.025.025 0 0 1 .024-.015c.01 0 .02.006.023.015L7.176 8.46H3.843Z"
  }))));
};

export default SvgGradientWhiteRichText;